import ArrowIcon from '@components/ArrowIcon';
import Fade from '@components/Animation/Fade';
import DataSetProvider from '@components/DataSetProvider';
import {LEFT, RIGHT} from '@constants/direction';
import type DataSet from '@interfaces/DataSet';
import type {Direction} from '@interfaces/Direction';
import type {ScrollerButtonProps} from '@interfaces/Scroller';
import classNames from 'classnames';
import type {ReactElement} from 'react';

interface Props extends ScrollerButtonProps {
    direction: Direction;
    isShown: boolean;
    onClick(direction: Direction): void;
}

export default function ScrollerButton(props: Props): ReactElement<Props> {
    function handleClick() {
        props.onClick(props.direction);
    }

    const className = classNames({
        [`scroller__button--${props.direction}`]: true,
        [props.className!]: props.className,
    });

    return (
        <DataSetProvider dataSet={props.dataSet}>
            {(dataSet: DataSet) => (
                <Fade in={props.isShown} unmountOnExit>
                    <div
                        className={className}
                        onClick={handleClick}
                        style={props.style ? props.style : {}}
                        {...dataSet}
                    >
                        <ArrowIcon
                            left={props.direction === LEFT}
                            right={props.direction === RIGHT}
                        />
                    </div>
                </Fade>
            )}
        </DataSetProvider>
    );
}
